<template>
  <div class="Site PageBox" style="background-color: var(--background-main)">
    <van-nav-bar
      fixed
      :border="false"
      :title="$t('Share[0]')"
      left-arrow
      style=""
      @click-left="$router.go(-1)"
    />
    <div class="ScrollBox">
      <van-swipe :autoplay="3000" indicator-color="#fff" style="height: 8.5rem;margin: 10px 15px;border-radius: 10px;z-index:3">
        <van-swipe-item v-for="(item,index) in InitData.homebannerList" :key="index">
          <img :src="InitData.setting.up_url+item.img_path" width="100%" height="100%">
        </van-swipe-item>
      </van-swipe>
      <div class="box-shadow"></div>
      <div class="group-title">
        <b>{{$t('Share[1][0]')}}</b><span>{{$t('Share[1][1]')}}</span>
      </div>
      <div v-if="listData.length" class="list">
        <div v-for="item,index in listData" :key="index" class="grid">
          <div class="item">
            <div>
              <img :src="`${InitData.setting.up_url}${item.cover_img}`" height="42">
              <h3>{{item.title}}</h3>
              <div class="reward">+ {{InitData.currency}}{{item.reward}}</div>
              <div class="con" v-if="item.content" v-html="item.content"></div>
            </div>
            <van-button round size="small" color="linear-gradient(to left,#ff9555,#ff4035)" @click="item.url?$router.push(item.url):$router.push(`/shareStep/${item.id}`)">{{item.an_title?item.an_title:$t('Share[1][2]')}}</van-button>
          </div>
        </div>
      </div>
      <van-empty v-else :image="`./static/icon/no_data.png`" :description="$t('vanPull[1]')" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Share',
  components: {

  },
  props: [],
  data() {
    return {
      listData: '',
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$Model.GetShareList(data=>{
      this.listData = data
    })
  },
  mounted() {
    
  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    
  }
}
</script>
<style scoped>
.box-shadow {
  height: 5px;
  box-shadow: 0 4px 10px #ea6b5d;
  margin: -15px 25px 0;
  position: relative;
  z-index: 2;
}
.group-title {
  padding: 0 15px;
  font-size: 12px;
  line-height: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 30px 0 15px;
}
.group-title b{
  font-size: 16px;
  display: flex;
  align-items: center;
}
.group-title b:before{
  content: '';
  width: 6px;
  height: 6px;
  background-color: var(--color-active);
  border-radius: 100px;
  margin-right: 5px;
}
.group-title span{
  color: var(--color-active);
}
.list{
  display: flex;
  flex-wrap: wrap;
  padding: 0 10px;
  margin-bottom: 30px;
}
.list .grid{
  flex-basis: 50%;
  padding: 5px;
}
.list .item{
  background-color: var(--background-main);
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.1);
  padding: 15px;
  border-radius: 10px;
  height: 100%;
  line-height: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
.list .item h3{
  font-size: 15px;
  font-weight: 600;
  margin: 15px 0;
}
.list .item .reward{
  color: var(--color-active);
}
.list .item .con{
  margin-top: 5px;
}
.list .item .con>>>*{
  color: var(--color-assist)!important;
  font-size: 12px!important;
}
.list .item .van-button{
  margin-top: 15px;
  padding: 0 15px;
}
</style>